import ButtonModel, { ButtonType } from '@mm/state/model/ButtonModel';
import { FormEntry } from '@mm/state/model/FormsModel';
import { TYPES } from '../../../editor/features/build/components/widgets/constants/quickQuestion';

// These methods could probably be written better but wanted to extract them
// from the component quickly

const isType = (type: string, buttons: ButtonModel[]) =>
  buttons.length === 1 && buttons[0].type === type;

const isPhoneType = (buttons: ButtonModel[]) =>
  isType(ButtonType.PHONE_NUMBER, buttons);

const isEmailType = (buttons: ButtonModel[]) =>
  isType(ButtonType.EMAIL, buttons);

const isTextType = (field: FormEntry) => {
  return (
    !isPhoneType(field.buttons) &&
    !isEmailType(field.buttons) &&
    field.allowFreeTextResponse
  );
};

const isMultipleType = (field: FormEntry) => {
  return (
    !isPhoneType(field.buttons) &&
    !isEmailType(field.buttons) &&
    !field.allowFreeTextResponse
  );
};

const getType = (field: FormEntry) => {
  if (isEmailType(field.buttons)) {
    return TYPES.EMAIL;
  }

  if (isPhoneType(field.buttons)) {
    return TYPES.PHONE;
  }

  if (isTextType(field)) {
    return TYPES.TEXT;
  }

  if (isMultipleType(field)) {
    return TYPES.MULTIPLE;
  }

  return null;
};

export const FormWidgetHelpers = {
  getType,
};
